'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SIZE_CLASSES = exports.SIZE_CLASSES = {
  responsive: '',
  xs: 'private-avatar--xs',
  sm: 'uiAvatarSmall private-avatar--sm',
  md: 'uiAvatarMedium private-avatar--md',
  lg: 'uiAvatarLarge private-avatar--lg',
  xl: 'uiAvatarXLarge private-avatar--xl'
};

var ICON_SIZES = exports.ICON_SIZES = {
  md: 10,
  lg: 12,
  xl: 18
};

var AVATAR_SIZES = exports.AVATAR_SIZES = {
  xs: 24,
  sm: 32,
  md: 48,
  lg: 72,
  xl: 118,
  responsive: 100
};

var RETINA_MULTIPLIER = exports.RETINA_MULTIPLIER = 2;

var DEFAULT_BASE = 'https://static.hsappstatic.net/salesImages/static-1.270/avatars';
var DEFAULT_COMPANY_AVATAR = exports.DEFAULT_COMPANY_AVATAR = DEFAULT_BASE + '/default-company-avatar.png';
var DEFAULT_CONTACT_AVATAR = exports.DEFAULT_CONTACT_AVATAR = DEFAULT_BASE + '/default-avatar.png';

var API_KNOWN_KEY_MAPPINGS = exports.API_KNOWN_KEY_MAPPINGS = {
  'contact': 'knownContacts',
  'company': 'knownCompanies'
};

var API_KNOWN_VALUE_MAPPINGS = exports.API_KNOWN_VALUE_MAPPINGS = {
  'contact': {
    'primaryIdentifier': 'vid',
    'secondaryIdentifier': 'email'
  },
  'company': {
    'primaryIdentifier': 'companyId',
    'secondaryIdentifier': 'domain'
  }
};

var API_IDENTIFIER_MAPPINGS = exports.API_IDENTIFIER_MAPPINGS = {
  'contact': 'vids',
  'company': 'companyIds',
  'vid': 'vids',
  'companyId': 'companyIds',
  'email': 'emails',
  'domain': 'domains',
  'enrichmentEmail': 'emails',
  'enrichmentDomain': 'domains',
  'hubSpotUserEmail': 'hubSpotUserEmails'
};

var DEFAULT_AVATAR_MAPPINGS = exports.DEFAULT_AVATAR_MAPPINGS = {
  'contact': DEFAULT_CONTACT_AVATAR,
  'vid': DEFAULT_CONTACT_AVATAR,
  'email': DEFAULT_CONTACT_AVATAR,
  'enrichmentEmail': DEFAULT_CONTACT_AVATAR,
  'company': DEFAULT_COMPANY_AVATAR,
  'companyId': DEFAULT_COMPANY_AVATAR,
  'domain': DEFAULT_COMPANY_AVATAR,
  'enrichmentDomain': DEFAULT_COMPANY_AVATAR,
  'hubSpotUserEmail': DEFAULT_CONTACT_AVATAR
};

var DEFAULT_MAX_UPLOAD_SIZE_MB = exports.DEFAULT_MAX_UPLOAD_SIZE_MB = 4;

var OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = exports.OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = {
  'contact': 'contacts/vid',
  'vid': 'contacts/vid',
  'company': 'companies/companyId',
  'companyId': 'companies/companyId'
};

var OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = exports.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = ['contact', 'vid', 'company', 'companyId'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-1.613/js/Constants.js
// module id = 109
// module chunks = 0 1